var swiper = new Swiper(".homeSlider", {
  spaceBetween: 0,

  speed: 900,
  autoplay: {
    delay: 4500,
    disableOnInteraction: true,
    allowTouchMove: true,
    simulateTouch: true,
    pauseOnMouseEnter: true,
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  // Mobile-first breakpoints
  breakpoints: {
    320: {
      // Mobile settings
      allowTouchMove: true,
      simulateTouch: true,
      touchStartPreventDefault: false,
    },
    761: {
      // Desktop settings
      allowTouchMove: false,
      simulateTouch: false,
    },
  },
});

document.addEventListener("DOMContentLoaded", function () {
  var isMobile = window.matchMedia(
    "only screen and (max-width: 760px)"
  ).matches;

  if (isMobile) {
    document.getElementById("mobile-video").classList.remove("hidden");
  } else {
    document.getElementById("desktop-video").classList.remove("hidden");
  }

  // Function to create mute/unmute button
  function createMuteButton(video, containerClass) {
    const controlContainer = document.createElement("div");
    controlContainer.classList.add(containerClass);

    const muteButton = document.createElement("button");
    muteButton.innerHTML = video.muted ? "Unmute" : "Mute";
    muteButton.classList.add(video.muted ? "unmute-button" : "mute-button");
    muteButton.addEventListener("click", function () {
      video.muted = !video.muted;
      muteButton.innerHTML = video.muted ? "Unmute" : "Mute";
      muteButton.classList.toggle("mute-button");
      muteButton.classList.toggle("unmute-button");
    });

    controlContainer.appendChild(muteButton);
    video.parentNode.insertBefore(controlContainer, video.nextSibling);
  }

  // Get the desktop and mobile video elements
  const desktopVideo = document.getElementById("desktop-video");
  const mobileVideo = document.getElementById("mobile-video");

  // Create custom controls for each video
  if (desktopVideo) createMuteButton(desktopVideo, "desktop-control-container");
  if (mobileVideo) createMuteButton(mobileVideo, "mobile-control-container");

  // Function to stop Swiper autoplay when video is played
  function stopAutoplayOnPlay(video) {
    video.addEventListener("play", function () {
      swiper.autoplay.stop();
    });
  }

  if (desktopVideo) stopAutoplayOnPlay(desktopVideo);
  if (mobileVideo) stopAutoplayOnPlay(mobileVideo);

  // Function to handle video muting/unmuting based on visibility
  function handleVisibilityChange(entries, observer) {
    entries.forEach((entry) => {
      const video = entry.target;
      if (entry.isIntersecting) {
        // Video is in view
        if (video.getAttribute("data-was-muted") === "true") {
          video.muted = true;
        }
      } else {
        // Video is out of view
        if (!video.muted) {
          video.setAttribute("data-was-muted", "false");
        } else {
          video.setAttribute("data-was-muted", "true");
        }
        video.muted = true;
      }
    });
  }

  // Create an Intersection Observer
  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.5, // Adjust as needed
  };
  const observer = new IntersectionObserver(
    handleVisibilityChange,
    observerOptions
  );

  // Observe both videos
  if (desktopVideo) observer.observe(desktopVideo);
  if (mobileVideo) observer.observe(mobileVideo);
});
